<template>
    <div class="area-analysis flow-container">
        <ParamsHeader></ParamsHeader>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>流量趋势</span>
                </div>
            </template>
            <div style="padding: 0px 20px 20px; display: flex; margin-top: 20px">
                <div style="flex: 4; margin-right: 10px">
                    <ChartMap class="chart-normal" ref="first-chart"></ChartMap>
                </div>
                <div style="flex: 6">
                    <ChartMap class="chart-normal" ref="second-chart"></ChartMap>
                </div>
            </div>
        </Card>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>集客力和游逛深度趋势</span>
                </div>
            </template>
            <div style="padding: 0px 20px 20px; display: flex; margin-top: 20px">
                <div style="flex: 1; border: 1px solid #e3e3e3">
                    <ChartMap class="chart-normal" ref="third-chart"></ChartMap>
                </div>
                <div style="flex: 1; border: 1px solid #e3e3e3; border-left: 0">
                    <ChartMap class="chart-normal" ref="fourth-chart"></ChartMap>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
import ParamsHeader from "../components/ParamsHeader";

export default {
    name: "areaAnalysis",
    components: {
        ParamsHeader,
    },
    data() {
        return {};
    },
    methods: {
        buildChart() {
            let firstChart = this.firstChart();
            this.$refs["first-chart"].setData(firstChart);
            let secondChart = this.secondChart();
            this.$refs["second-chart"].setData(secondChart);
            let thirdChart = this.thirdChart();
            this.$refs["third-chart"].setData(thirdChart);
            let fourthChart = this.fourthChart();
            this.$refs["fourth-chart"].setData(fourthChart);
        },
        firstChart() {
            let option = {
                title: {
                    text: "各大区客流当期对比",
                    left: "center",
                },
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    top: "bottom",
                },
                series: [
                    {
                        name: "大区分布",
                        type: "pie",
                        center: ["50%", "50%"],
                        itemStyle: {
                            borderRadius: 8,
                        },
                        data: [
                            { value: 40, name: "华北区" },
                            { value: 38, name: "华南区" },
                            { value: 32, name: "华东区" },
                            { value: 30, name: "华中区" },
                        ],
                    },
                ],
            };
            return option;
        },
        secondChart() {
            let option = {
                color: ["#FFD03F", "#A5A5A5", "#F09557", "#F5F5F5"],
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                title: {
                    text: "各大区客流趋势",
                    left: "center",
                },
                legend: {
                    top: 30,
                    data: ["华北区", "华南区", "华东区", "华中区"],
                },
                grid: {
                    top: 80,
                    left: "3%",
                    right: "4%",
                    containLabel: true,
                },
                dataZoom: [
                    {
                        show: true,
                        realtime: true,
                        start: 0,
                        end: 100,
                    },
                ],
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: ["2020-1", "2020-2", "2020-3", "2020-4", "2020-5", "2020-6", "2020-7", "2020-8", "2020-9", "2020-10", "2020-11", "2020-12"],
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: [
                    {
                        type: "value",
                        name: "客流量(人次)",
                    },
                ],
                series: [
                    {
                        name: "华北区",
                        data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],
                        type: "line",
                        smooth: true,
                    },
                    {
                        name: "华南区",
                        data: [3.9, 5.9, 11.1, 18.7, 48.3, 69.2, 231.6, 46.6, 55.4, 18.4, 10.3, 0.7],
                        type: "line",
                        smooth: true,
                    },
                    {
                        name: "华东区",
                        data: [3.5, 4.9, 10.1, 15.7, 20.3, 50.2, 121.6, 80.6, 90.4, 66.4, 10.3, 11.5],
                        type: "line",
                        smooth: true,
                    },
                    {
                        name: "华中区",
                        data: [6.9, 8.9, 15.1, 25.7, 60.3, 69.2, 201.6, 76.6, 65.4, 28.4, 18.3, 9.7],
                        type: "line",
                        smooth: true,
                    },
                ],
            };
            return option;
        },
        thirdChart() {
            let option = {
                color: ["#FFD03F", "#A5A5A5", "#F09557", "#F5F5F5"],
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                title: {
                    text: "大区集客力趋势",
                    left: "center",
                },
                legend: {
                    bottom: 15,
                    data: ["华北区", "华南区", "华东区", "华中区"],
                },
                grid: {
                    top: 50,
                    left: "3%",
                    right: "4%",
                    bottom: 50,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: ["2020Q1", "2020Q2", "2020Q3", "2020Q4"],
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: [
                    {
                        type: "value",
                    },
                ],
                series: [
                    {
                        name: "华北区",
                        data: [120, 132, 101, 134],
                        type: "line",
                    },
                    {
                        name: "华南区",
                        data: [220, 182, 191, 234],
                        type: "line",
                    },
                    {
                        name: "华东区",
                        data: [150, 232, 201, 154],
                        type: "line",
                    },
                    {
                        name: "华中区",
                        data: [320, 332, 301, 334],
                        type: "line",
                    },
                ],
            };
            return option;
        },
        fourthChart() {
            let option = {
                color: ["#FFD03F", "#A5A5A5", "#F09557", "#F5F5F5"],
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                title: {
                    text: "大区游逛深度趋势",
                    left: "center",
                },
                legend: {
                    bottom: 15,
                    data: ["华北区", "华南区", "华东区", "华中区"],
                },
                grid: {
                    top: 50,
                    left: "3%",
                    right: "4%",
                    bottom: 50,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: ["2020Q1", "2020Q2", "2020Q3", "2020Q4"],
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: [
                    {
                        type: "value",
                    },
                ],
                series: [
                    {
                        name: "华北区",
                        data: [120, 132, 101, 134],
                        type: "line",
                    },
                    {
                        name: "华南区",
                        data: [220, 182, 191, 234],
                        type: "line",
                    },
                    {
                        name: "华东区",
                        data: [150, 232, 201, 154],
                        type: "line",
                    },
                    {
                        name: "华中区",
                        data: [320, 332, 301, 334],
                        type: "line",
                    },
                ],
            };
            return option;
        },
    },
    mounted() {
        this.buildChart();
    },
};
</script>

<style scoped></style>
